import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  barChart: {
    paddingHorizontal: 60,
  },

  notice:{
    flex: 1,
    alignItems: 'center',
    paddingVertical: 20
  },
  note:{


  }


});
